import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getFiscalShortName = (
  fiscalType: string,
  countryRegistration: string
) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP
        ? 'Abbreviated name IP*'
        : 'Short company name*',
      rus: ft === FiscalType.IP
        ? 'Сокращенное наименование ИП*'
        : 'Краткое название компании*',
      kz: ft === FiscalType.IP
        ? 'Қысқартылған атау IP*'
        : ft === FiscalType.JSC
        ? 'Қысқартылған атау АҚ*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Қысқартылған атау ЖАҚ*'
        : ft === FiscalType.OsOO
        ? 'Қысқартылған атау ЖШС*'
        : 'Қысқартылған атау ЖШС*',
    },
    placeholder: {
      eng: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'IP «Lastochka»' : 'IP «MPK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'JSC «APK»' : 'JSC «MPK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'PJSC «APK»' : 'PJSC «MPK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'CJSC «APK»' : 'CJSC «MPK»'
        : ft === FiscalType.OsOO
        ? countryRegistration === '417' ? 'LLP «APK»' : 'LLP «MPK»'
        : 'LLC «MPK»',
      rus: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'ИП «Ласточка»' : 'ИП «MПK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'АО «АПK»' : 'АО «MПK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'ПАО «АПK»' : 'ПАО «MПK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'ЗАО «АПK»' : 'ЗАО «MПK»»'
        : ft === FiscalType.OsOO && countryRegistration === '417'
        ? 'ОсОО «АПK»'
        : 'ООО «MПK»',
      kz: ft === FiscalType.IP
        ? countryRegistration === '417' ? 'IP «Martïn»' : 'IP «MPK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '417' ? 'АҚ «APK»' : 'АҚ «MPK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '417' ? 'ЖАҚ «APK»' : 'ЖАҚ «MPK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '417' ? 'ЖАҚ «APK»' : 'ЖАҚ «MPK»'
        : ft === FiscalType.OsOO
        ? countryRegistration === '417' ? 'ЖШС «APK»' : 'ЖШС «MPK»'
        : 'ЖШС «MPK»',
    },
  }
}
